import IcoMoonJSON from 'common/static/icons.json';
var Icons = {};

IcoMoonJSON.icons.forEach(icon => {
    const unicode = String.fromCodePoint(icon.properties.code);
    Icons = { ...Icons, [icon.properties.name]: { unicode } };
});

export default Icons;
